import { Customer } from "shared";
import { AccountSettings } from "../AccountSettings";
import { DriversClub } from "../DriversClub";
import { Region } from "../Region";
import { Welcome } from "../Welcome";
import { useFeatureFlag } from "../../app/Providers/AppContext";
import { Insurance } from "../Insurance";
import { BillingAlerts } from "../BillingAlerts";

type AccountProfileProps = {
  customer: Customer;
};

export const AccountProfile = ({ customer }: AccountProfileProps) => {
  const { ACCOUNT_SETTINGS } = useFeatureFlag();

  return (
    <div className="container container_center">
      <div className="d-flex justify-content-center">
        <main
          id="main"
          className="col xs-size_1-of-1 lg-size_9-of-12 xl-size_8-of-12"
        >
          <Welcome>{customer.firstName}</Welcome>
          <BillingAlerts />
          <Insurance />
          <DriversClub />

          {ACCOUNT_SETTINGS.treatment === "base" && (
            <Region
              title="Account Settings"
              contentSlot={<AccountSettings initialCustomer={customer} />}
            />
          )}
        </main>
      </div>
    </div>
  );
};
